export default {"src":"/accounts/_next/static/media/Email.44121e78.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};